import { IForm } from "../../../models/response/form/IForm";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
export const objFormDefine = {
    LOAD_START: "",
    LOAD_SUCCESS: [] as IForm[],
    LOAD_ERROR: "",
    LOAD_COSO_START: 0,
    LOAD_COSO_SUCCESS: [] as IForm[],
    LOAD_COSO_ERROR: "",
    SHOW_EDIT_MODAL: {} as IForm | undefined,
    CLOSE_EDIT_MODAL: undefined,
    SAVE_START: {} as IForm,
    SAVE_SUCESS: {} as IForm,
    SAVE_ERROR: "",
    DELETE_START: 0,
    DELETE_SUCESS: undefined,
    DELETE_ERROR: "",
    LOCK_START: 0,
    LOCK_SUCESS: undefined,
    LOCK_ERROR: "",
    UNLOCK_START: 0,
    UNLOCK_SUCESS: undefined,
    UNLOCK_ERROR: "",
};

export const eFormActionTypeIds = generateActionTypeIds(objFormDefine, "FORM")
export type IFormActionTypes = IGenericActionType<typeof objFormDefine, "FORM">
